module.exports = __webpack_public_path__ + "img/abbott.08d24ea2.jpg";